import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useProgressStore = create(
  persist(
    (set) => ({
      // Progress state
      isActive: false,
      isValidating: false,
      isSubmitting: false,
      isCompleted: false,
      uploadProgress: 0,
      updateProgress: 0,
      validationMessage: '',
      submissionMessage: '',
      successMessage: '',
      
      // Position state for draggable functionality
      position: { right: '20px', bottom: '20px', left: 'auto', top: 'auto' },
      
      // Actions
      setActive: (active) => set({ isActive: active }),
      setValidating: (validating) => set({ 
        isValidating: validating, 
        isCompleted: false,
        isActive: validating ? true : false 
      }),
      setSubmitting: (submitting) => set({ 
        isSubmitting: submitting, 
        isCompleted: false,
        isActive: submitting ? true : false 
      }),
      setUploadProgress: (progress) => set({ uploadProgress: progress }),
      setUpdateProgress: (progress) => set({ updateProgress: progress }),
      setValidationMessage: (message) => set({ validationMessage: message }),
      setSubmissionMessage: (message) => set({ submissionMessage: message }),
      setPosition: (position) => set({ position }),
      
      // Complete the operation with success message
      completeOperation: (message) => set({ 
        isValidating: false,
        isSubmitting: false,
        isCompleted: true,
        successMessage: message || 'Operation completed successfully!',
        uploadProgress: 100,
        updateProgress: 100
      }),
      
      // Reset all states
      reset: () => set({ 
        isActive: false,
        isValidating: false,
        isSubmitting: false,
        isCompleted: false,
        uploadProgress: 0,
        updateProgress: 0,
        validationMessage: '',
        submissionMessage: '',
        successMessage: ''
      })
    }),
    {
      name: 'progress-storage', // unique name for localStorage
    }
  )
)

export default useProgressStore
